import script from "./InfoBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoBlock.vue?vue&type=script&lang=ts&setup=true"

import "./InfoBlock.vue?vue&type=style&index=0&id=739fabd3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739fabd3"]])

export default __exports__